// removed by extract-text-webpack-plugin
module.exports = {"About":"About__About__Nt9kt","Title":"About__Title__3ayNX","Section":"About__Section__1eODu","SectionTitle":"About__SectionTitle__1CPeI","DatabaseInfo":"About__DatabaseInfo__1us_w","VersionInfo":"About__VersionInfo__3qvVc","TechnicalInfo":"About__TechnicalInfo__1sDWY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.css
// module id = 615
// module chunks = 0